'use strict';
import PerfectScrollbar from 'perfect-scrollbar';

export function Scrollbar() {

  const modalTexts = document.querySelectorAll('.p-modal__txt');

  modalTexts.forEach(el => {
    const ps = new PerfectScrollbar(el, {
      wheelSpeed: 2,
      wheelPropagation: true,
      minScrollbarLength: 20,
    });
  })

}
